import { useCallback, useEffect, useMemo, useState } from 'react';

export const useCountDown = (time = 0, autoStart = 'stop') => {
	const [counter, setCounter] = useState(time);
	const [status, setStatus] = useState(() => (!autoStart ? 'stop' : autoStart));

	useEffect(() => {
		if (counter <= 0 || status === 'stop' || status === 'pause') {
			return;
		}

		const timer = setInterval(() => {
			setCounter(prev => prev - 1)
		}, 1000);

		return () => clearInterval(timer);
	}, [counter, status]);

	const currentNum = useMemo(() => counter, [counter]);
	const start = useCallback(() => setStatus('start'), []);
	const pause = useCallback(() => setStatus('pause'), []);

	const restart = useCallback((newTime = time) => {
		setCounter(() => newTime);
		setStatus('start');
	}, [time]);

	return {
		counter: currentNum,
		start,
		pause,
		restart,
	};
};
